import { useIntl } from 'react-intl'
import type { FieldsConfiguration } from 'msp-components'
import {
  isGermanDate,
  isStandardDate,
  isValidMachineSerial
} from 'msp-integrations'
import translations from './AccountMachineUpdate.constants'

const getUpdateMachineFields = (): FieldsConfiguration => {
  const { formatMessage } = useIntl()

  return {
    SerialNo: {
      id: 'SerialNo',
      type: 'text',
      name: 'SerialNo',
      placeholder: '',
      label: formatMessage(translations.formFieldSerialNo),
      rules: {
        required: formatMessage(translations.formFieldSerialNoError),
        validate: {
          isValidSerialNo: (val) =>
            isValidMachineSerial(val) ||
            formatMessage(translations.formFieldSerialNoPatternError)
        }
      }
    },
    purchaseDate: {
      type: 'text',
      id: 'purchaseDate',
      name: 'purchaseDate',
      placeholder: formatMessage(translations.formFieldPurchaseDatePlaceholder),
      label: formatMessage(translations.formFieldPurchaseDate),
      rules: {
        required: formatMessage(translations.formFieldPurchaseDateError),
        validate: {
          isValidDate: (val) =>
            isGermanDate(val) ||
            isStandardDate(val) ||
            formatMessage(translations.formFieldPurchaseDatePatternError)
        }
      }
    }
  }
}

export default getUpdateMachineFields
